export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/craft_lessons.990bbbd.svg";